import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=3c23d42e&scoped=true&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=3c23d42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23d42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\email-shipping\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c23d42e')) {
      api.createRecord('3c23d42e', component.options)
    } else {
      api.reload('3c23d42e', component.options)
    }
    module.hot.accept("./CartItem.vue?vue&type=template&id=3c23d42e&scoped=true&", function () {
      api.rerender('3c23d42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmailShipping/components/CartItem.vue"
export default component.exports